import "./loader.css";
function Loader() {
    return (

        <div className="flex fixed inset-0 z-50 justify-center items-center bg-black bg-opacity-50">
            <div className="loader"></div>
        </div>

    )
}

export default Loader